import React, { useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useSecureData } from "../backend/secureDataProvider";
import axiosWithHandling from "../backend/axiosHanding";
import { apiURL } from "../backend/ApiURLs";
import "../design/resetPassword.css"

export default function ResetPasswordForm() {
    const {inputKey} = useParams();
    const {secureData} = useSecureData();
    const userID = secureData?.userID

    const [newPassword, setNewPassword] = useState("")
    const [newPasswordConfirm, setNewPasswordConfirm] = useState("")
    const [errorMessage, setErrorMessage] = useState(null);    
    const [isSubmitting, setIsSubmitting] = useState(false);

    var sha256 = require('js-sha256');
    const hashedNewPassword = sha256(newPassword)

    const url = `${apiURL}resetCredentials/changeToNewPassword?userID=${encodeURIComponent(userID)}&resetPasswordToken=${encodeURIComponent(inputKey)}&newPassword=${encodeURIComponent(hashedNewPassword)}`

    
    const navigate = useNavigate();
    const handleSubmit = async () => {
        setIsSubmitting(true)
        const isValidPassword = validatePassword(newPassword, newPasswordConfirm)
        
        if (isValidPassword != "") {
            setErrorMessage(isValidPassword)
            setIsSubmitting(false)
            return
        }

        axiosWithHandling(url, {
            method : "POST"
        })
        .then(data => {
            setIsSubmitting(false)
            navigate('/resetPasswordSuccess')
        })
        .catch(error => {
            setIsSubmitting(false)
            var statusCode = error.message

            setErrorMessage(validateResponseFromServer(statusCode))
        })
    }

    const validatePassword = (password, passwordConfirm) => {

        // check password is greater than 8 characters
        if (password.length < 8) {
          return "Password must be longer than 8 characters";
        }
    
        // check confrim is the same
        if (password != passwordConfirm) {
          return "Passwords must match";
        }
    
        return "";
    }

    const validateResponseFromServer = (statusCode) => {
        if (statusCode == 404) {
            return "Invalid URL, please request another reset password email"
        }
    
        if (statusCode == 403) {
            return "Web page has been refreshed, please try again from the link in your email link"
        }
    
        if (statusCode == 401) {
            return "URL has already been used to reset password, please request another reset password email"
        }
    
        if (statusCode == 406) {
            return "URL has already been used to reset password, please request another reset password email"
        }

        if (statusCode == 409) {
            return "Old password cannot be new password"
        }
    
        return `Unkown error: ${statusCode}`
    }

    return (
        <div>
            <h1 className="header"> Reset Your Password </h1>
            <div className="resetPasswordBackground">
                
                <label className="label">
                New Password
                    <input type="password" className="newPassword" onChange={(e) => setNewPassword(e.target.value)}></input>
                </label>

                <label className="label">
                Confirm Password
                    <input type="password" className="newPassword" onChange={(e) => setNewPasswordConfirm(e.target.value)}></input>
                </label>

                <div className="errorMessage">
                    {errorMessage}
                </div>                

                <button className="submitButton" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? "Resetting" : "Reset Password"}
                </button>
        
            </div>
        </div>

        
    )

    
}